import * as network from './player'
import * as psserver from './serveraccess'
import * as pscommand from '../commands'
import * as marietta from '../../../marietta';

export class communication {

    protected streamingPlayer: network.player | null = null;

    private abController: AbortController | null = null;

    protected receivers: network.receiver[] = [];

    private _sendDelay = 1000;
    public set sendDelay(value) {
        this._sendDelay = value;
    }


    private _status: number;
    public get status(): number {
        return this._status;
    }
    public set status(value) {
        this._status = value;
    }

    constructor() {
        this._status = network.statustype.unknown;
    }

    public addReceiver(reciver_: network.receiver) {
        this.receivers.push(reciver_);
    }

    // pixelstreaming
    public serverAccess() {
        console.log("Server Access Test -\n");

        this._status = -100;     //待機
        const server = new psserver.psserver();
        server.get().then((jsonstr) => {
            console.log(jsonstr);

            if (!jsonstr) return;

            const object = JSON.parse(jsonstr);
            if (object == null) {
                return Promise.reject(new Error("JSONの取得に失敗しました."));
            }
            if (object.status == 404) {
                marietta.webcad.WebCADGlobal.showAlert(object.message);
                this.status = 0;
                this.networkStatus(network.statustype.unknown);
                return Promise.resolve();
            }

            this.streamingPlayer = new network.player(object.host, object.port);

            this.streamingPlayer.addReceiver(new newtworkStatus(this));

            this.receivers.forEach((receiver) =>this.streamingPlayer.addReceiver(receiver));

            this.streamingPlayer.connect();
        }).catch((str) => {
            console.log(str);
            marietta.webcad.WebCADGlobal.showAlert(`サーバーへのアクセスに失敗しました。<br>${str}`);
            this.status = 0;
            this.networkStatus(network.statustype.unknown);
        });
    }

    // テストコード
    public wsAccess() {
        const url = 'wss://isp-cloud-company-web.marietta.co.jp:443?host=176.32.76.124&port=91';

        this.streamingPlayer = new network.player(url);

        this.streamingPlayer.addReceiver(new newtworkStatus(this));

        this.receivers.forEach((receiver) =>this.streamingPlayer.addReceiver(receiver));

        this.streamingPlayer.connect();
    }

    protected networkStatus(status) {
        this.receivers.forEach((receiver_: network.receiver) => {
            const rev = <network.playerStatus>receiver_;
            if (rev.onChange) {
                rev.onChange(status);
            }
        });
    }

    private senddata(json: string) {
        this.receivers.forEach((receiver_: network.receiver) => {
            const rev = <network.sendStatus>receiver_;
            if (rev.onSend) {
                rev.onSend(json);
            }
        });
    }

    // 接続解除
    public disconnect() {
        if (this.streamingPlayer == null) return;
        this.streamingPlayer.disconnect();
    }

    public canSend(): boolean {
        return this.streamingPlayer && this._status == network.statustype.connect;
    }

    // 送信
    public send(object) {
        // console.log(`pixelstreaming send object - ${JSON.stringify(object)}`);
        console.log('send');

        if (!this.canSend()) return;

        if (object == null) {
            console.warn('communication.send(obj): undefined object !!');
            return;
        }
        this.streamingPlayer.emitUIInteraction(object);
        this.senddata(JSON.stringify(object));
    }

    //
    public abortTimer() {
        if (this.abController) {
            this.abController.abort();
            this.abController = null;
        }
    }
    // 遅延送信
    //
    public sendWithTimer(object) {

        if (object == null) {
            console.warn('communication.sendWithTimer(obj): undefined object !!');
            return;
        }

        if (this.abController) {
            this.abController.abort();
        }

        this.abController = new AbortController();
        const { signal } = this.abController;

        const promise = new Promise((resolve, reject) => {

            const timerID = setTimeout(() => {
                // console.log(`pixelstreaming send object - ${JSON.stringify(object)}`);
                console.log('sendWithTimer');
                if (this.canSend()) {
                    this.streamingPlayer.emitUIInteraction(object);
                    this.senddata(JSON.stringify(object));
                }
                resolve(48);
            }, this._sendDelay);

            signal.addEventListener(
                "abort",
                () => {
                    clearTimeout(timerID);
                    reject(20);
                },
                {
                    once: true,
                }
            );
        });

        promise.then((num) => {
            ;
        }).catch((num) => {
            // console.log("Rejected! ", num)
        });
    }

    // - create scene ------
    // GLB, Extras送信
    // カメラデータ送信
    // public createScene(glbdata: ArrayBuffer, extras, camera: pscommand.cameraStatus) {
    //     const sendglb = () => {
    //         return new Promise((resolve) => {
    //             const glb = new pscommand.GLB(glbdata);

    //             const datas = glb.object();

    //             datas.forEach((data) => {
    //                 console.log(`send GLB ${data}`);
    //                 this.send(data);
    //             });
    //             resolve(resolve);
    //         });
    //     }

    //     const sendExtras = () => {
    //         return new Promise((resolve) => {
    //             const ext = new pscommand.divideSceeneEtras(extras);

    //             const datas = ext.object();

    //             datas.forEach((data) => {
    //                 console.log(`send extras - ${data}`);
    //                 // this.send(data);
    //             });
    //             resolve(resolve);
    //         });
    //     }

    //     sendglb()
    //         .then(() => {
    //             this.send(new pscommand.sceneextras(extras).object());
    //         }).then(() => {
    //             this.send(camera.object());
    //         }).then(() => {
    //             sendExtras().then(() => {
    //                 console.log('');
    //             })
    //             // const unfreezCommand = new pscommand.develop('unfreeze');
    //             // this.send(unfreezCommand.object());
    //         });
    // }
}

export class newtworkStatus implements network.playerStatus
 {
    constructor(private communication: communication) {
    }

    public onChange(status) {
        if (status === network.statustype.connect) {
            console.log('Connect - PSS DataChannel');
        }
        if (status == network.statustype.disconnect) {
            ;
        }
        this.communication.status = status;
    }
 }


